<template>
  <div class="home-echarts-wrap" :style="{ width, height, marginBottom }">
    <div class="home-echarts-header" style="padding: 10px 24px 0 24px;height: auto">
      <h3 class="home-echarts-header__title">{{ title }}</h3>
    </div>
    <!-- 延迟显示 loading 效果。当 spinning 状态在 delay 时间内结束，则不显示 loading 状态。 -->
    <a-spin :spinning="spinning" :delay="200">
      <!-- echarts 图表 -->
      <div ref="chartRef" class="home-echarts-content" v-show="showECharts"></div>
      <dc-layout-empty type="nothing" v-if="!showECharts"/>
    </a-spin>
  </div>
</template>
<script setup lang="ts">
import type { PropType, Ref } from 'vue'
import { useECharts } from '@/hooks/useECharts'
import { computed, onBeforeMount, ref, toRef, watch } from 'vue'
import { getVisitCustomerCompletion } from '@/api/gucangSales/dataBoard'

interface ApiDataType {
  clueVisitTarget?: number, // 线索拜访目标
  clueVisitCompleted?: number, // 线索拜访完成
  potentialVisitTarget?: number, // 潜在拜访目标
  potentialVisitCompleted?: number, // 潜在拜访完成
  contractVisitTarget?: number, // 签约拜访目标
  contractVisitCompleted?: number, // 签约拜访完成
  transactionVisitTarget?: number, // 成交拜访目标
  transactionVisitCompleted?: number, // 成交拜访完成
}

const props = defineProps({
  title: {
    type: String as PropType<string>,
    default: '客户拜访完成情况'
  },
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_lbu'>,
    required: true
  },
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '350px'
  },
  marginBottom: {
    type: String as PropType<string>,
    default: '8px'
  },
  formState: {
    type: Object as PropType<Object>
  }
})
watch(() => props.formState, (newValue) => {
  getData()
})
const spinning = ref(false)
const showECharts = ref(false)
const getData = () => {
  spinning.value = true
  getVisitCustomerCompletion(props.formState).then((res) => {
    const data = res.data as ApiDataType
    if (data) {
      showECharts.value = true
      const targetList: number[] = [data.clueVisitTarget ?? 0, data.potentialVisitTarget ?? 0, data.contractVisitTarget ?? 0, data.transactionVisitTarget ?? 0]
      const completeList: number[] = [data.clueVisitCompleted ?? 0, data.potentialVisitCompleted ?? 0, data.contractVisitCompleted ?? 0, data.transactionVisitCompleted ?? 0]
      initChart(targetList, completeList)
    } else {
      showECharts.value = false
      initChart([], [])
    }
  }).finally(() => {
    spinning.value = false
  })
}
const xAxisData = ['销售线索', '潜在客户', '签约客户', '成交客户']
const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>, undefined, false)

const initChart = (targetVisitList: number[], completeVisitList: number[]) => {
  setOptions({
    // 悬浮窗
    tooltip: {
      trigger: 'item',
      backgroundColor: '#1D4CD2',
      textStyle: {
        color: '#fff'
      },
      formatter: function (params) {
        const currentAxis = xAxisData[params.dataIndex]
        const targetHoverData = targetVisitList[params.dataIndex]
        const completionHoverData = completeVisitList[params.dataIndex]
        const toolsTipsResult = []
        toolsTipsResult.push(currentAxis)
        toolsTipsResult.push('拜访目标  <strong>' + targetHoverData + '</strong>')
        toolsTipsResult.push('实际拜访  <strong>' + completionHoverData + '</strong>')
        return toolsTipsResult.join('<br>')
      }
    },
    /// 在这里配置线条颜色和legend颜色一致
    color: ['#DDE3EE', '#1D4CD2'],
    legend: {
      itemWidth: 12,
      itemHeight: 2,
      left: 'right',
      icon: 'react',
      right: '50%',
      data: ['拜访目标', '实际拜访']
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: xAxisData
    },
    yAxis: {
      type: 'value',
      min: 0,
      splitLine: {
        show: true,
        lineStyle: {
          color: '#D8DFE4',
          type: 'dashed'
        }
      }
    },
    series: [
      {
        name: '拜访目标',
        type: 'bar',
        barWidth: '30%',
        data: targetVisitList
        // lineStyle: {
        //   color: 'rgb(245, 101, 101)'
        //   // // 设置线条的style等
        //   // normal: {
        //   //   color: 'rgb(60,179,113)'
        //   // }
        // },
      },
      {
        name: '实际拜访',
        type: 'bar',
        barWidth: '30%',
        barGap: '-10%', // 设置与前一个柱状图组之间的间距为50%
        data: completeVisitList
        // lineStyle: {
        //   color: 'rgb(56, 161, 105, 1)'
        //   // // 设置线条的style等
        //   // normal: {
        //   //   color: 'rgb(255,99,71)'
        //   // }
        // },
      }
    ]
  })
}
onBeforeMount(() => {
  getData()
})
</script>
<script lang="ts">
export default { name: 'CustomerVisitCompletionStatus' }
</script>
<style scoped lang="scss">

</style>
